<div
    class="card text-white bg-info"
    style="border: 2px solid"
    [ngStyle]="{ 'border-color': task.multipickingTaskIdentifierColor }"
>
    <span *ngIf="task.superOrderCode" class="badge badge-danger">
        {{ 'my-tasks.multi-store-collecting-badge' | translate }}:
        {{ task.superOrderCode }}
    </span>
    <button
        class="p-1 m-1 btn btn-success"
        *ngIf="customerChat && customerChatInfo?.userId"
        (click)="openChat()"
    >
        {{ 'common.customer-chat' | translate }}&nbsp;<i class="fa fa-envelope"></i>
    </button>
    <div class="card-header" [ngClass]="{ 'ml-5': maximumMultipickingTasks > 1 }">
        <div
            class="multi-picking-task-identifier"
            *ngIf="task.multipickingTaskIdentifierChar"
            [ngStyle]="{ 'background-color': task.multipickingTaskIdentifierColor }"
        >
            {{ task.multipickingTaskIdentifierChar }}
        </div>
        <div class="multi-picking-chkbx" *ngIf="maximumMultipickingTasks > 1">
            <input
                type="checkbox"
                [checked]="isMultiPickingSelectedTask"
                [attr.disabled]="
                    (multiPickingSelectedTasks?.length >= maximumMultipickingTasks &&
                        !isMultiPickingSelectedTask) ||
                    (multiPickingSelectedTasks?.length > 0 &&
                        this.multiPickingSelectedTasks[0]?.providerName !==
                            this.multiPickingTask.providerName) ||
                    multiPickingAlreadyInProgress
                        ? true
                        : null
                "
                (change)="changed($event)"
            />
        </div>
        <div (click)="isCollapsed = !isCollapsed">
            <span>
                <strong>{{ task.deliveryTimeSlot }}</strong
                >,
            </span>
            <span>
                <strong>{{ task.customerZipCode }}</strong
                >,
            </span>
            <span>
                <strong>{{ task.providerName }}</strong
                >,
            </span>
            <span>
                <strong>{{ task.orderItemNumber }} SKU</strong>
            </span>
            <button
                (click)="showProductListModal()"
                class="btn btn-success mx-2 float-right"
            >
                <span><i class="fa fa-check-circle"></i></span>
            </button>
        </div>
        <div *ngIf="task.calculatedPriceEnabled" class="text-dark">
            <i class="fa fa-money"></i>&nbsp;
            {{ task.calculatedPrice }}
            {{ 'common.currency' | translate }}&nbsp;
            <button
                type="button"
                class="btn btn-primary btn-sm"
                (click)="showCalculatedPriceInfoModal()"
            >
                <span><i class="fa fa-info-circle"></i></span>
            </button>
        </div>
    </div>
    <div class="card-body text-center" [collapse]="isCollapsed" [isAnimated]="true">
        <h5 class="card-title">{{ task.customerName }}</h5>
        <table class="table table-striped table-responsive table-borderless text-white">
            <tbody>
                <tr>
                    <th scope="row">{{ 'common.provider-shop' | translate }}:</th>
                    <td>
                        <a
                            href="http://maps.google.com/maps?q={{ task.providerShop }}"
                            class="text-white"
                            target="_blank"
                        >
                            <u>{{ task.providerShop }}</u>
                        </a>
                    </td>
                </tr>
                <tr>
                    <th scope="row">{{ 'common.payment-type' | translate }}:</th>
                    <td>
                        {{
                            'payment-type.' + PaymentType[task.paymentType].toLowerCase()
                                | translate
                        }}
                    </td>
                </tr>
                <tr>
                    <th scope="row">{{ 'common.phone' | translate }}:</th>
                    <td>
                        <a href="tel:{{ task.customerPhone }}" class="text-white">
                            <u>
                                {{ task.customerPhone }}
                            </u>
                        </a>
                    </td>
                </tr>
                <tr>
                    <th scope="row">{{ 'my-tasks.customer-zip-code' | translate }}:</th>
                    <td>
                        {{ task.customerZipCode }}
                    </td>
                </tr>
                <tr>
                    <th scope="row">{{ 'my-tasks.order-code' | translate }}:</th>
                    <td>
                        {{ task.orderCode }}
                    </td>
                </tr>

                <!-- TODO: Estimated Delivery Time (https://weshop.atlassian.net/browse/SP-3994) -->

                <tr>
                    <th scope="row">{{ 'my-tasks.delivery-deadline' | translate }}:</th>
                    <td>
                        <span>{{
                            task.deliveryDeadline
                                | amAdd : task.timeSlotVisualShiftMinutes : 'minutes'
                                | amDateFormat : 'HH:mm'
                        }}</span>
                        <span *ngIf="task.deliveryTimeSlotEnd != null">
                            -
                            {{
                                task.deliveryDeadline
                                    | amAdd
                                        : task.deliveryTimeSlotEnd +
                                              task.timeSlotVisualShiftMinutes
                                        : 'minutes'
                                    | amDateFormat : 'HH:mm'
                            }}
                        </span>
                    </td>
                </tr>

                <!-- TODO END -->

                <tr>
                    <th scope="row">{{ 'my-tasks.bag' | translate }}:</th>
                    <td *ngIf="task.usePaperBag; else multiUseBag">
                        {{ 'my-tasks.paper-bag' | translate }}
                    </td>
                    <ng-template #multiUseBag>
                        <td *ngIf="task.usePaperBag === false">
                            {{ 'my-tasks.multiuse-bag' | translate }}
                        </td>
                    </ng-template>
                </tr>
                <tr>
                    <th scope="row">{{ 'common.notes' | translate }}:</th>
                    <td>
                        {{ task.notes }}
                    </td>
                </tr>
            </tbody>
        </table>
        <app-deliverer-notes
            [isVisible]="isDelivererNotesVisible"
            [orderID]="task.orderID"
            [delivererNotes]="task.delivererNotes"
        ></app-deliverer-notes>
    </div>
    <div [collapse]="isCollapsed" [isAnimated]="true">
        <app-wish-list-buttons
            [orderCode]="task.orderCode"
            [customerPhone]="task.customerPhone"
            [wishListOrders]="task.wishListOrders"
        ></app-wish-list-buttons>
    </div>
    <div class="card-footer" [collapse]="isCollapsed" [isAnimated]="true">
        <app-collecting-task-button [task]="task"></app-collecting-task-button>
    </div>
</div>
